// src/pages/categoryItem/components/documents/getDocumentFileUrl.ts

import { getBaseUrl } from "../../../config/runtimeConfig";
import { DocumentInterface } from "../../types/types";

export const getDocumentFileUrl = (document: DocumentInterface): string => {
  if (!document.filePath) return "";
  return `${getBaseUrl()}/file?path=${document.filePath}`;
};
